/* eslint-disable */
// automatically generated by the FlatBuffers compiler, do not modify

import * as flatbuffers from 'flatbuffers';

import { FSWebviewNotRecordedReason } from './fswebview-not-recorded-reason';

export class FSFBWebEventLoadNotRecorded {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): FSFBWebEventLoadNotRecorded {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsFSFBWebEventLoadNotRecorded(
    bb: flatbuffers.ByteBuffer,
    obj?: FSFBWebEventLoadNotRecorded,
  ): FSFBWebEventLoadNotRecorded {
    return (obj || new FSFBWebEventLoadNotRecorded()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsFSFBWebEventLoadNotRecorded(
    bb: flatbuffers.ByteBuffer,
    obj?: FSFBWebEventLoadNotRecorded,
  ): FSFBWebEventLoadNotRecorded {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new FSFBWebEventLoadNotRecorded()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  domain(): string | null;
  domain(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  domain(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  reason(): FSWebviewNotRecordedReason {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? this.bb!.readInt16(this.bb_pos + offset)
      : FSWebviewNotRecordedReason.DOMAIN_NOT_ALLOWLISTED;
  }

  static startFSFBWebEventLoadNotRecorded(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addDomain(builder: flatbuffers.Builder, domainOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, domainOffset, 0);
  }

  static addReason(builder: flatbuffers.Builder, reason: FSWebviewNotRecordedReason) {
    builder.addFieldInt16(1, reason, FSWebviewNotRecordedReason.DOMAIN_NOT_ALLOWLISTED);
  }

  static endFSFBWebEventLoadNotRecorded(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createFSFBWebEventLoadNotRecorded(
    builder: flatbuffers.Builder,
    domainOffset: flatbuffers.Offset,
    reason: FSWebviewNotRecordedReason,
  ): flatbuffers.Offset {
    FSFBWebEventLoadNotRecorded.startFSFBWebEventLoadNotRecorded(builder);
    FSFBWebEventLoadNotRecorded.addDomain(builder, domainOffset);
    FSFBWebEventLoadNotRecorded.addReason(builder, reason);
    return FSFBWebEventLoadNotRecorded.endFSFBWebEventLoadNotRecorded(builder);
  }
}
